import { MODEL_BY_LABEL, MODEL_LABEL_TEMPLATE_URL, MODEL_URL } from "api/routes";
import { modelsInstance } from "hooks/useRequest/helper";

export const getModels = async (pageParam, encodeParams, params) => {
  params.skip = ((pageParam > 0 ? pageParam : 1) - 1) * (params?.limit ?? 7)

  return await modelsInstance.get(
    MODEL_URL,
    { headers: { "filter-query": encodeParams ?? "{}" }, params }
  );
};

export const getModelByID = async ({ id }) => {
  return await modelsInstance.get(`${MODEL_URL}/${id}`);
};

export const getModelsByMaterial = async (pageParam, encodeParams, { params, material }) => {
  if (!material) return

  params.skip = pageParam * (params?.limit ?? 8)

  return await modelsInstance.get(
    MODEL_BY_LABEL + "/" + material,
    { headers: { "filter-query": encodeParams }, params }
  );
};

export const getModelsByCategory = async (pageParam, { params, label }) => {
  if (!label) return

  params.page = pageParam

  return await modelsInstance.get(
    MODEL_BY_LABEL + "/" + label, { params }
  );
};

export const getModelLabels = async (params) => {
  return await modelsInstance.get(MODEL_LABEL_TEMPLATE_URL, { params });
};